<template>
  <div id="app">
    <notification-center/>

    <div class="main">
      <router-view/>
    </div>

    <blog-modal/>

    <side-nav/>
    <player/>
    <post-inspector/>
    <share-modal/>
    <blog-picker-dialog/>
    <feedback/>

    <how-to-post-video/>

    <cooke-banner />

  </div>
</template>

<script>
  import MainNavigation from './components/layout/MainNavigation.vue';
  import NotificationCenter from './components/layout/NotificationCenter.vue';
  import Player from './components/player/Player.vue';
  import BlogModal from './components/blogs/BlogModal';
  import ShareModal from './components/layout/ShareModal.vue';
  import BlogPickerDialog from './components/ui/BlogPickerDialog.vue';
  import Feedback from './components/layout/FeedbackWidget';
  import SideNav from "./components/layout/SideNav";
  import HowToPostVideo from "./components/content/HowToPostVideo";
  import PostInspector from "./components/posts/PostInspector";
  import CookeBanner from './components/layout/CookieBanner';


export default {
    name: 'app',
    metaInfo: {
        meta: [
          {name:'title', vmid: 'title', content:'Pimblr - The new way of watching porn'},
          {name:'description', vmid: 'description', content:'Pimblr is a community for sharing curated porn videos. Follow blogs with the same interests or create your own Pimblr Blog.'},

          {property: 'og:title', content: 'Pimblr - The new way of watching porn'},
          {property: 'og:site_name', content: 'Pimblr'},
          {property: 'og:type', content: 'website'},
          {property: 'og:url', content: 'https://pimblr.com'},
          {property: 'og:image', content: 'https://pimblr.com/static/LogoFlyer.png'},

          {name: 'twitter:card', content: 'summary'},
          {name: 'twitter:site', content: 'https://pimblr.com'},
          {name: 'twitter:title', content: 'Pimblr - The new way of watching porn'},
          {name: 'twitter:description', content: 'Pimblr is a community for sharing curated porn videos. Follow blogs with the same interests or create your own Pimblr Blog.'},

          {itemprop: 'name', content: 'Pimblr - The new way of watching porn'},
          {itemprop: 'description', content: 'Pimblr is a community for sharing curated porn videos. Follow blogs with the same interests or create your own Pimblr Blog.'},
          {itemprop: 'image', content: 'https://pimblr.com/static/LogoFlyer.png'}

        ],
        titleTemplate: (titleChunk) => {
          return titleChunk ? `${titleChunk} - Pimblr` : 'Pimblr';
        }
    },
    created(){
        const token = localStorage.getItem('token');
        if(token){
            this.$store.commit('user/setToken', token);
            this.$store.dispatch('user/init', token)
                .then((res)=>{

                    if(!localStorage.getItem('message_4ae46fb5619b')) {
                        this.$nextTick(() => {
                            this.$bus.$emit('ShowHowToPostVideo');
                        });
                        localStorage.setItem('message_4ae46fb5619b', '1');
                    }

                })
                .catch((err)=>{
                    this.$store.state.waitForStore = true;
                    this.$router.push('/login');
                })

        }
    },
    components: {
      PostInspector,
        HowToPostVideo,
        SideNav,
        navigation: MainNavigation,
        NotificationCenter,
        Player,
        BlogModal,
        ShareModal,
        BlogPickerDialog,
        Feedback,
        CookeBanner
    }
}
</script>

<style lang="sass">

  @import "assets/bootstrap/bootstrap"
  @import "assets/sass/global"

  .main
    padding-top: 70px


</style>



// WEBPACK FOOTER //
// src/App.vue